/**
 * 사업자등록번호 포맷으로 변환합니다. (nnn-nn-nnnnn)
 * @param value
 * @returns string
 */
export default function formatBusinessNumber(value: string) {
  return value?.replace(/^(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
}
